"use client";
import Image from "next/image";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch} from "react-redux";
import { openModal } from "@/slice/whatsappModalSlice";

export default function StepsCare() {
  const intl = useIntl();
  const dispatch = useDispatch();


  return (
    <div className="bg-white ">
      <div className=" flex flex-col-reverse lg:flex-row items-start lg:items-center justify-start lg:justify-between lg:gap-10 xl:gap-16 gap-10 lg:pt-0 lg:pb-8 -mt-4 lg:mt-0 pb-6 max-w-[1440px] mx-auto lg:px-[30px] px-5 overflow-x-clip">
        {/* Image Section */}
        <div className=" hidden md:flex-1 lg:flex items-center lg:justify-start justify-start items-start relative lg:ml-0 min-w-0">
          <div className="md:relative lg:w-full lg:max-w-[520px] lg:h-[620px] xl:max-w-[650px] xl:h-[760px] w-[280px] h-[350px] mb-4 -ml-5 lg:ml-0">
            <Image
              src="/images/Rectangle.svg"
              alt={intl.formatMessage({
                id: "stepsCare.imageAlt",
                defaultMessage: "Steps Care",
              })}
              fill
              className="
                            absolute
                            bottom-0
                            left-0 -translate-x-0 lg:left-1/2 lg:-translate-x-[10%]
                            w-[250px] md:w-[340px] lg:w-[300px] xl:w-[340px]
                            h-auto
                            -z-0
                            scale-x-[-1]
                            "
            />
            <Image
              src="/images/Care-guidance.svg"
              alt={intl.formatMessage({
                id: "stepsCare.imageAlt2",
                defaultMessage: "Doctor with patient",
              })}
              width={582}
              height={900}
              className="
                            absolute
                            bottom-0
                            left-0 -translate-x-0 lg:left-1/2 lg:-translate-x-1/2
                            lg:w-[340px] lg:h-[560px] xl:w-[420px] xl:h-[700px] w-[220px]
                            h-auto
                            z-10
                            scale-x-[-1]
                            ml-2
                            "
            />
          </div>
        </div>

        {/* Text Section */}
        <div className="flex-1 w-full flex flex-col min-w-0">
          <div className="lg:mb-8 mb-4 lg:leading-4 lg:pr-4">
            <h1 className="font-roboto-slab lg:text-[26px] xl:text-[30px] text-[20px] text-[#00428A] font-semibold leading-snug lg:mb-2 mb-1">
              {intl.formatMessage({
                id: "stepsCare.headingPart1",
                defaultMessage: "Someone stays with you —",
              })}
            </h1>
            <span className="font-roboto-slab lg:text-[26px] xl:text-[30px] text-[20px] font-extralight text-[#404248] leading-snug xl:whitespace-nowrap">
              {intl.formatMessage({
                id: "stepsCare.headingPart2",
                defaultMessage: "so you don't have to manage this alone",
              })}
            </span>
          </div>

          <div className="font-roboto-slab text-[13px] lg:text-[16px] font-medium text-gray-700 lg:mb-2 tracking-wide">
            <p>
              {intl.formatMessage(
                {
                  id: "stepsCare.paragraph1",
                  defaultMessage: "Most people come to {fitsib} are supporting a loved one,",
                },
                {
                  fitsib: <span key="fitsib" className="text-[#00428A] font-medium">Fitsib</span>,
                }
              )}
            </p>
            <p>
              {intl.formatMessage({
                id: "stepsCare.paragraph2",
                defaultMessage: "We stand with you, so you don't carry it alone",
              })}
            </p>
          </div>

          <h3 className="font-roboto lg:text-[18px] text-[16px] font-medium text-[#00428A] tracking-wide ">
            {intl.formatMessage({
              id: "stepsCare.subheading",
              defaultMessage: "What we take care for you",
            })}
          </h3>

          <div className="flex flex-col items-start justify-start gap-6 mt-5 ">
            <div className="flex flex-row items-center lg:gap-4 gap-1 mb-0 ">
              <div className="flex-shrink-0 lg:w-[50px] lg:h-[50px] w-[60px] h-[60px]">
                <Image
                  src="/images/Doctor-care.svg"
                  alt={intl.formatMessage({
                    id: "stepsCare.item1",
                    defaultMessage: "Helping you understand doctors, treatments and surgery options.",
                  })}
                  width={50}
                  height={50}

                />
              </div>
              <p className="font-roboto lg:text-[16px] text-[14px] text-[#404248] lg:leading-relaxed tracking-wide ">
                {intl.formatMessage({
                  id: "stepsCare.item1",
                  defaultMessage: "Helping you understand doctors, treatments and surgery options.",
                })}
              </p>
            </div>

            <div className="flex flex-row items-center lg:gap-4 gap-1 mb-0 ">
              <div className="flex-shrink-0 lg:w-[50px] lg:h-[50px] w-[60px] h-[60px]">
                <Image
                  src="/images/Care-step.svg"
                  alt={intl.formatMessage({
                    id: "stepsCare.item2",
                    defaultMessage: "We take time to explain each step before anything proceeds.",
                  })}
                  width={50}
                  height={50}
                />
              </div>
              <p className="font-roboto lg:text-[16px] text-[14px] text-[#404248] lg:leading-relaxed tracking-wide">
                {intl.formatMessage({
                  id: "stepsCare.item2",
                  defaultMessage: "We take time to explain each step before anything proceeds.",
                })}
              </p>
            </div>

            <div className="flex flex-row items-center lg:gap-4 gap-1 mb-0">
              <div className="flex-shrink-0 lg:w-[50px] lg:h-[50px] w-[60px] h-[60px]">
                <Image
                  src="/images/Step-coordinator.svg"
                  alt={intl.formatMessage({
                    id: "stepsCare.item3",
                    defaultMessage: "From doctors conversations to hospital, travel and logistics we handle it all.",
                  })}
                  width={50}
                  height={50}
                />
              </div>
              <p className="font-roboto lg:text-[16px] text-[14px] text-[#404248] lg:leading-relaxed tracking-wide">
                {intl.formatMessage({
                  id: "stepsCare.item3",
                  defaultMessage: "From doctors conversations to hospital, travel and logistics we handle it all.",
                })}
              </p>
            </div>

            <div className="flex flex-row items-center lg:gap-4 gap-1 mb-0">
              <div className="flex-shrink-0 lg:w-[50px] lg:h-[50px] w-[60px] h-[60px]">
                <Image
                  src="/images/Care-person.svg"
                  alt={intl.formatMessage({
                    id: "stepsCare.item4",
                    defaultMessage: "One dedicated Care Coordinator stays with you through every step.",
                  })}
                  width={50}
                  height={50}
                />
              </div>
              <p className="font-roboto lg:text-[16px] text-[14px] text-[#404248] lg:leading-relaxed tracking-wide">
                {intl.formatMessage({
                  id: "stepsCare.item4",
                  defaultMessage: "One dedicated Care Coordinator stays with you through every step.",
                })}
              </p>
            </div>

            <div className="flex flex-row items-center lg:gap-4 gap-1 mb-0">
              <div className="flex-shrink-0 lg:w-[50px] lg:h-[50px] w-[60px] h-[60px]">
                <Image
                  src="/images/Support.svg"
                  alt={intl.formatMessage({
                    id: "stepsCare.item5",
                    defaultMessage: "Support that respects your pace and your comfort.",
                  })}
                  width={50}
                  height={50}
                />
              </div>
              <p className="font-roboto lg:text-[16px] text-[14px] text-[#404248] lg:leading-relaxed tracking-wide">
                {intl.formatMessage({
                  id: "stepsCare.item5",
                  defaultMessage: "Support that respects your pace and your comfort.",
                })}
              </p>
            </div>

            <div className="flex flex-row items-center lg:gap-4 gap-1 mb-2">
              <div className="flex-shrink-0 lg:w-[50px] lg:h-[50px] w-[60px] h-[60px]">
                <Image
                  src="/images/Care-to-recovery.svg"
                  alt={intl.formatMessage({
                    id: "stepsCare.item6",
                    defaultMessage: "Walking with you through treatment to recovery.",
                  })}
                  width={50}
                  height={50}
                />
              </div>
              <p className="font-roboto lg:text-[16px] text-[14px] text-[#404248] lg:leading-relaxed tracking-wide">
                {intl.formatMessage({
                  id: "stepsCare.item6",
                  defaultMessage: "Walking with you through treatment to recovery.",
                })}
              </p>
            </div>
          </div>

          <div className="mt-4 flex justify-center ">
            <button
              className="font-robot block w-full max-w-[360px] mx-auto text-[#00428A] lg:text-[16px] text-[14px] font-regular lg:py-2 lg:px-14 py-[8px] px-[16px] border border-[#00428A] rounded-full hover:bg-[#003366] hover:text-white transition-colors text-center"
              onClick = {()=>dispatch(openModal())}
            >
              {intl.formatMessage({
                id: "stepsCare.button",
                defaultMessage: "Talk to Us",
              })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}